<script lang="ts">
  import * as _ from 'lodash';
  import type { SellSheetRetailerUser } from '@shared/types/User';
  import type { SellSheet } from '@shared/types/SellSheet';
  import Icon from '@shared/svelte/Components/Icon.svelte';
  import ShareSelectRetailerCard from './ShareSelectRetailerCard.svelte';

  export let sharingWithRetailers: SellSheetRetailerUser[] = [];
  export let searchRetailers: (distributorId: number, searchTerm: string) => Promise<SellSheetRetailerUser[]>;
  export let retailersLoaded = false;
  export let sellSheet: SellSheet;
  export let responsiveLayout: boolean = false;

  let retailerUsers:SellSheetRetailerUser[] = [];
  $: retailerUsers = retailerUsers;
  $: noSearchResults = false;
  $: selectedRetailersIds = [];
  $: searchValue = "";
  $: {
    if(retailersLoaded && searchValue != ""){ retailerSearch() }
  }

  $: showMenu = false;
  const toggleMenu = () => {
    showMenu = !showMenu
  }

  const runSearch = async function() {
    retailerUsers = [];
    selectedRetailersIds = [];
    noSearchResults = false;

    if(!searchValue) { return }
    retailerUsers = await searchRetailers(sellSheet.distributor_id, searchValue)

    if( !retailerUsers || retailerUsers.length === 0) { noSearchResults = true }
  }
  let retailerSearch = _.debounce(runSearch, 250)

  function retailerName(user: any) {
    return user.first_name + " " + user.last_name
  }

  function phoneFormat(phoneNumber: number) {
    if(!phoneNumber) { return "" }
    let pattern = '(###) ###-####';
    var i = 0;
    var v = phoneNumber.toString();
    return pattern.replace(/#/g, _ => v[i++]);
  }

  function highlight(string: string) {
    let searchTerms = searchValue.split(" ");
    searchTerms.forEach(function(searchTerm){
      searchTerm = searchTerm.replace(/[^a-z0-9]/gi,'')
      if(searchTerm === "") return

      let regex = new RegExp(searchTerm, 'gi');
      string = string.replace(regex, '--->$&<---');
    });

    string = string.replace(new RegExp('--->', 'gi'),"<span class='fizz-text-strong'>");
    string = string.replace(new RegExp('<---', 'gi'),"</span>");
    return string;
  }

  function removeRetailer(retailerUser: SellSheetRetailerUser) {
    sharingWithRetailers = sharingWithRetailers.filter(ru => ru !==  retailerUser)
    selectedRetailersIds = selectedRetailersIds.filter(ruId => ruId !== retailerUser.id)
  }

  function addRetailer(retailerUser: SellSheetRetailerUser) {
    if(sharingWithRetailers.includes(retailerUser)) return

    let found = retailerUsers.find(ru => ru.id === retailerUser.id);
    sharingWithRetailers.push(found);
    sharingWithRetailers = sharingWithRetailers
    selectedRetailersIds.push(retailerUser.id)
    selectedRetailersIds = selectedRetailersIds

    if(responsiveLayout && !showMenu) {
      toggleMenu()
    }
  }

  function clickRetailerDiv(retailerUser: SellSheetRetailerUser) {
    let index = selectedRetailersIds.indexOf(retailerUser.id)
    index > -1 ? removeRetailer(retailerUser) : addRetailer(retailerUser)
  }
</script>

<style lang='scss'>
  .scroll-menu {
    position: relative;
    height: 13rem;
    overflow-y: auto;
  }

  .responsive-width {
    width: 229px;
    @media (max-width: 700px) {
      width: 100%;
    }
  }

  .sharing-with-section {
    position: relative;
    @media (min-width: 700px) {
      overflow-y: auto;
      height: 17rem;
    }
  }

  .invisible-scroll {
    &::-webkit-scrollbar {
      width: 0px;
    }
  }
</style>

<section class="select-retailers fizz-flex-row-responsive fizz-align-content-start"
  class:fizz-stack-64={!responsiveLayout} class:fizz-stack-16={responsiveLayout}>
  <div class="fizz-full-width fizz-flex-item" class:fizz-border-bottom={responsiveLayout}
    class:fizz-inset-squish-16={responsiveLayout} class:fizz-stack-4={responsiveLayout}>
    <h4 class="fizz-stack-8 fizz-text-strong">Search your retailers</h4>
    <input
      type="text"
      name="search"
      id="share-sell-sheet-search-retailers"
      class="fizz-input-search responsive-input fizz-full-width fizz-stack-8"
      placeholder={responsiveLayout ? "" : "Enter a name, retailer, email, or phone"}
      bind:value={searchValue}
      on:keyup={retailerSearch}
    >
    {#if searchValue && retailerUsers.length}
      <div class="scroll-menu" class:fizz-bordered={!responsiveLayout} class:invisible-scroll={responsiveLayout}>
        <div class="fizz-full-width" class:fizz-inset-square-16={!responsiveLayout} style="position: absolute;">
          {#each retailerUsers as retailerUser}
            {#key retailerUser}
              {#key selectedRetailersIds}
                <ShareSelectRetailerCard {selectedRetailersIds} {retailerUser} {retailerName}
                  {clickRetailerDiv} {highlight} {phoneFormat} sellSheetId={sellSheet.id} {responsiveLayout} />
              {/key}
            {/key}
          {/each}
        </div>
      </div>
    {/if}
    {#if noSearchResults && retailersLoaded}
      <div class="fizz-inset-square-16 fizz-stack-8" style="text-align: center;">
        <h4 class="fizz-text-strong">No Retailers</h4>
        <h4>There are no retailers that match your search</h4>
      </div>
    {:else if retailersLoaded == false && searchValue != ""}
      <div class="fizz-flex-row fizz-justify-center">
        <div class="fizz-icon-spinner-small fizz-inset-square-8"></div>
      </div>
    {/if}
  </div>

  <div class="responsive-width" class:fizz-full-width={responsiveLayout} class:fizz-stack-64={!responsiveLayout}>
    <div class="fizz-flex-row fizz-space-between" class:fizz-inset-squish-16={responsiveLayout} class:fizz-border-bottom={responsiveLayout}>
      <h4 class="fizz-text-strong" class:fizz-stack-8={!responsiveLayout}>Sharing with ({sharingWithRetailers.length})</h4>
      {#if responsiveLayout}
        <button class="fizz-icon-button-small show-in" style="background-color: unset; padding-left: 0.5rem;" on:click={toggleMenu}>
          <Icon
            width="14"
            height="14"
            type={showMenu ? "ArrowUp" : "ArrowDown"}>
          </Icon>
        </button>
      {/if}
    </div>

    {#if showMenu || !responsiveLayout}
      <div class="fizz-full-width sharing-with-section" class:fizz-bordered={sharingWithRetailers.length && !responsiveLayout}>
        {#if sharingWithRetailers.length}
          {#each sharingWithRetailers as selectedRetailer}
            <div class="fizz-flex-row fizz-inset-square-8 fizz-space-between fizz-border-bottom" class:fizz-inset-squish-16={responsiveLayout}>
              <p class="">
                {retailerName(selectedRetailer.user)}
              </p>
              <div class='remove-retailer-from-share-list fizz-inline-8'
                on:click={() => removeRetailer(selectedRetailer)}>
                <Icon type='X' extraClassNames='cursor-pointer' height='9' width='9'></Icon>
              </div>
            </div>
          {/each}
        {:else if !responsiveLayout}
          <div class="fizz-inset-squish-24 fizz-bordered">
            <div class="fizz-inset-square-16" style="text-align: center; margin-top: 2.5rem;">
              <h4 class="fizz-text-strong fizz-stack-16">No Retailers Selected</h4>
              <p class="fizz-stack-64">Search and Select <br> retailer to share this <br> product sheet</p>
            </div>
          </div>
        {/if}
      </div>
    {/if}
  </div>
</section>